import { render, staticRenderFns } from "./Coin.vue?vue&type=template&id=d59d265c"
import script from "./Coin.vue?vue&type=script&lang=js"
export * from "./Coin.vue?vue&type=script&lang=js"
import style0 from "./Coin.vue?vue&type=style&index=0&id=d59d265c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports